module.exports = __webpack_public_path__ + "03_veryshort_gold.82fc8d82.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_veryshort_gold.png
// module id = TZz8
// module chunks = 0